/**
 * @export
 * @class Checkout
 */
import { BaseModule } from '../../helpers/base_module';
import { Toggler } from '../../helpers/toggler';

export class Checkout extends BaseModule {
    public static id = 'checkout';

    constructor() {
        super();

        this.shipping();
        this.paymentMethods();
        this.toggleStripeCards();

        // Prevent the checkout_update events changing the scroll position
        jQuery( document.body ).on( 'checkout_error', function() {
            jQuery( 'html, body' ).stop();
        } );
    }


    /**
     * Toggle the shipping address block
     * 
     * @private
     * @return void
     */
    private shipping(): void {
        const container = document.getElementById('js-checkout__shipping');
        const input     = <HTMLInputElement>document.querySelector('.js-checkout__shipping-input');
        
        if(container && input) {
            const toggler = new Toggler(container, 'c-checkout__shipping--is-visible');

            if(input.checked) {
                toggler.add();
            } else {
                toggler.remove();
            }

            input.addEventListener('change', () => {
                if(input.checked) {
                    toggler.add();
                } else {
                    toggler.remove();
                }
            });
        }
    }


    /**
     * Toggles the payment methods to display the fields for the currently checked one
     * 
     * @private
     * @return void
     */
    private paymentMethods(): void {
        const inputs = document.querySelectorAll('.js-checkout__payment-method-input');
        if(inputs) {
            
            $.each(inputs, ({}, inputField) => {
                const input = inputField as HTMLInputElement;
                input.addEventListener('click', () => {

                    // Loop through all inputs, and open or close the fields if it's checked our not
                    $.each(inputs, ({}, innerInputField) => {
                        const innerInput = innerInputField as HTMLInputElement;
                        const parent = innerInput.closest('.js-checkout__payment-method');
                        if(parent) {

                            if(innerInput.checked) {
                                parent.classList.add('c-checkout__payment-method--is-open');
                            } else {
                                parent.classList.remove('c-checkout__payment-method--is-open');
                            }
                        }
                    });
                });
            });
        }
    }


    /**
     * Toggles the stripe form depending on whether the user has selected to use a new card or an existing one
     * 
     * @private
     * @memberof Checkout
     */
    private toggleStripeCards(): void {
        const existingCardElem = document.querySelector('.woocommerce-SavedPaymentMethods');
        const stripeForm       = document.getElementById('wc-stripe-cc-form');
        if(existingCardElem && stripeForm) {
            const newCheckbox = <HTMLInputElement>document.getElementById('wc-stripe-payment-token-new');
            if(newCheckbox) {
                
                // Open/Close it on page load
                if(newCheckbox.checked) {
                    stripeForm.classList.add('wc-credit-card-form--is-visible');
                } else {
                    stripeForm.classList.remove('wc-credit-card-form--is-visible');
                }

                // Open/Close it on change
                const radios = document.getElementsByName('wc-stripe-payment-token');
                $.each(radios, ({}, radioField) => {
                    const radio = radioField as HTMLInputElement;
                    radio.addEventListener('change', () => {
                
                        // Open/Close if the new card option it's checked
                        if(newCheckbox.checked) {
                            stripeForm.classList.add('wc-credit-card-form--is-visible');
                        } else {
                            stripeForm.classList.remove('wc-credit-card-form--is-visible');
                        }
                    });
                });
            }
        }
    }
}
